import React from "react";
import { useNavigate } from "react-router-dom";
import background from "./images/background.png";

const easyDuck =
  "https://res.cloudinary.com/dbvqeiqxb/image/upload/w_192,h_192,c_fill,f_auto,q_auto/v1773976500/patito_completa_frase_wpojtl.png";
const hardDuck =
  "https://res.cloudinary.com/dbvqeiqxb/image/upload/w_192,h_192,c_fill,f_auto,q_auto/v1773976296/patito_sopa_letras_eqlu7v.png";

const games = [
  {
    id: "completa",
    duckImg: easyDuck,
    title: "Completa la frase",
    description: "¿Te sabes sus frases de memoria, bb?\nA ver si es cierto.",
    badge: null,
    path: "/select-level",
    accent: "#7dd3fc",
  },
  {
    id: "sopa",
    duckImg: hardDuck,
    title: "Sopa de letras",
    description: "Las palabras están escondidas, bb.\nA ver si las encuentras.",
    badge: "NUEVO",
    path: "/sopa-de-letras",
    accent: "#c4b5fd",
  },
];

const SelectGame = () => {
  const navigate = useNavigate();

  return (
    <div
      className="flex flex-col font-quicksand"
      style={{
        backgroundImage: `url(${background})`,
        backgroundRepeat: "repeat-y",
        backgroundSize: "100% auto",
        backgroundPosition: "top center",
        minHeight: "calc(100vh - 120px)",
      }}
    >
      {/* Oráculo banner — slim strip pinned at the top, like DocumentalBanner */}
      <button
        onClick={() => navigate("/bola-magica")}
        className="w-full flex items-center gap-3 px-4 py-2.5 border-b border-white/10 font-quicksand active:opacity-80 transition-opacity"
        style={{ background: "linear-gradient(135deg, #2a1d4a, #170f2c)" }}
      >
        <span style={{ fontSize: "15px" }}>🔮</span>
        <div className="text-left flex-1">
          <p className="text-white font-bold text-sm leading-tight">
            Oráculo perrísimo
          </p>
          <p className="text-purple-300 text-[10px]">
            Haz tu pregunta y confía ✨
          </p>
        </div>
        <span
          className="font-bold text-xs whitespace-nowrap"
          style={{ color: "#c4b5fd" }}
        >
          Pregúntale →
        </span>
      </button>

      <div
        className="px-5 pt-6 pb-8 flex flex-col"
        style={{ minHeight: "inherit" }}
      >
        {/* Header */}
        <div className="mb-5">
          <p
            className="text-xs font-bold tracking-widest uppercase"
            style={{ color: "#b06ab3" }}
          >
            A jugar
          </p>
          <h1
            className="text-xl font-extrabold mt-0.5"
            style={{ color: "#2d1f3d" }}
          >
            ¿Qué jugamos hoy?
          </h1>
        </div>

        {/* Game cards */}
        <div className="flex flex-col gap-4" style={{ flex: 1 }}>
          {games.map((game) => (
            <button
              key={game.id}
              onClick={() => navigate(game.path)}
              className="w-full active:scale-[0.97] transition-transform relative flex flex-col items-center justify-center"
              style={{
                background: "rgba(255,255,255,0.9)",
                borderRadius: "28px",
                padding: "32px 20px",
                boxShadow: "0 4px 24px rgba(176,106,179,0.13)",
                border: `2px solid ${game.accent}`,
                flex: 1,
              }}
            >
              {game.badge && (
                <span
                  className="absolute top-4 right-4 text-white font-bold rounded-full"
                  style={{
                    background: "#f97316",
                    fontSize: "10px",
                    letterSpacing: "0.05em",
                    padding: "3px 10px",
                  }}
                >
                  {game.badge}
                </span>
              )}

              <img
                src={game.duckImg}
                alt={game.title}
                style={{
                  width: "120px",
                  height: "120px",
                  objectFit: "contain",
                  marginBottom: "14px",
                }}
              />

              <p
                className="font-extrabold text-lg leading-tight text-center"
                style={{ color: "#2d1f3d" }}
              >
                {game.title}
              </p>
              <p
                className="text-sm mt-2 leading-snug text-center whitespace-pre-line"
                style={{ color: "#9b7eaa" }}
              >
                {game.description}
              </p>
            </button>
          ))}
        </div>

        {/* Leaderboard button */}
        <button
          onClick={() => navigate("/leaderboard")}
          className="w-full active:scale-[0.97] transition-transform mt-4"
          style={{
            background: "rgba(255,255,255,0.9)",
            borderRadius: "20px",
            padding: "14px 20px",
            boxShadow: "0 4px 24px rgba(176,106,179,0.1)",
            border: "1.5px solid #f9a8d4",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span style={{ fontSize: "22px" }}>🏆</span>
            <div style={{ textAlign: "left" }}>
              <p
                className="font-extrabold text-sm"
                style={{ color: "#2d1f3d" }}
              >
                Leaderboard
              </p>
              <p className="text-xs" style={{ color: "#9b7eaa" }}>
                ¿Quién es la más perrísima?
              </p>
            </div>
          </div>
          <span style={{ color: "#c4b5fd", fontSize: "18px", fontWeight: 700 }}>
            ›
          </span>
        </button>
      </div>
    </div>
  );
};

export default SelectGame;
